/*Objeto que almacena los datos resultado de
  la sincronizacion de respuestas*/
export class SyncDataDTO{

    //Constructor de la clase
    constructor(

        //Flag que indica si la sincronizacion fue exitosa o no
        public syncResult: boolean,

        //indica el numero de registros que se debian sincronizar
        public registers: number,

        //numero de registros que fueron sincronizados
        public synced: number,

        //Indica si hubo errores en la sincronizacion
        public errors: boolean
    ){}
}
